import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, InputLabel, FormControl } from "@material-ui/core"
import { Close } from "@material-ui/icons";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from 'components/CustomButtons/Button';
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { useEffect, useState } from "react";

const DateRangePicker = (
    {
        initialStartDate,
        initialEndDate,
        showPicker = false,
        title = `Select a date range`,
        applyButtonLabel = "Apply",
        onApply = () => { },
        onClose = () => { },
    }
) => {

    //All Timestamps are handle in seconds, except initialStartDate &  initialEndDate

    const [startSec, setStartSec] = useState(initialStartDate ? moment(initialStartDate).startOf('day').unix() : moment().startOf('day').unix());
    const [endSec, setEndSec] = useState(initialEndDate ? moment(initialEndDate).endOf('day').unix() : moment().endOf('day').unix());

    const handleClose = () => {
        onClose();
    }

    const handleApplyButton = () => {
        if (startSec && endSec) {
            onApply(startSec, endSec);
            onClose();
        }
    }

    const onChangeDateTime = (state) => (value) => {

        let dateObj = value;
        if (typeof date === 'string') {
            const unix = moment(value, 'MMM Do').unix();
            if (!unix) return;
            dateObj = moment(unix * 1000);
        }
        if (!dateObj) return;

        if ('startSec' === state) {
            setStartSec(moment(dateObj).startOf('day').unix());
            if (moment(endSec*1000).isBefore(moment(dateObj))) {
                setEndSec(moment(dateObj).clone().endOf('day').unix());
            }
        }
        if ('endSec' === state) {
            setEndSec(moment(dateObj).endOf('day').unix());
            if (moment(startSec*1000).isAfter(moment(dateObj))) {
                setStartSec(moment(dateObj).clone().startOf('day').unix());
            }
        }
    }

    useEffect(()=> {
        if(showPicker){
            setStartSec(moment(initialStartDate).startOf('day').unix());
            setEndSec( moment(initialEndDate).endOf('day').unix());
        }
    }, [showPicker])


    return (
        <>
            <Dialog
                disableEscapeKeyDown
                open={showPicker ? true : false}
                onClose={handleClose}
                aria-labelledby="date-range-picker"
                maxWidth='sm'
                fullWidth
            >
                <DialogTitle id="date-range-picker">
                    {title}
                    <IconButton
                        style={{
                            position: 'absolute',
                            color: 'grey',
                            right: '14px',
                            top: '10px',
                        }}
                        onClick={handleClose}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <GridContainer>
                        <GridItem xs={12} sm={6} md={6}>
                            <InputLabel style={{ transform: 'translate(0, 1.5px) scale(0.75)' }}>
                                From
                            </InputLabel>
                            <FormControl fullWidth >
                                <Datetime
                                    dateFormat="MMM Do"
                                    timeFormat={false}
                                    open={true}
                                    inputProps={{ placeholder: "Select Start Date" }}
                                    formControlProps={{ fullWidth: true }}
                                    onChange={onChangeDateTime('startSec')}
                                    value={moment(startSec*1000).toDate()}
                                    className="rdt-inline"
                                />
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                            <InputLabel style={{ transform: 'translate(0, 1.5px) scale(0.75)' }}>
                                To
                            </InputLabel>
                            <FormControl fullWidth >
                                <Datetime
                                    dateFormat="MMM Do"
                                    timeFormat={false}
                                    open={true}
                                    inputProps={{ placeholder: "Select Start Date" }}
                                    formControlProps={{ fullWidth: true }}
                                    onChange={onChangeDateTime('endSec')}
                                    value={moment(endSec*1000).toDate()}
                                    className="rdt-inline"
                                />
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button onClick={handleApplyButton} color="rose">{applyButtonLabel}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default DateRangePicker;